define('Components/AboutComeInWidget/js/view/AboutComeInWidgetView',['jquery',
    'backbone',
    'SubView',
    'WidgetInstanceView',
    'app',
    'template!/Components/AboutComeInWidget/templates/default',
    'views/blocks/checkout/ComeInInformationsView',
    'InternalLinkView'
  ],
  function ($,
            Backbone,
            SubView,
            WidgetInstanceView,
            app,
            AboutComeInTemplate,
            ComeInInformationsView,
            InternalLinkView
  ) {

    var AdvantageModalView = Backbone.View.extend(SubView).extend({
        events:{
          'click .about-comein__modale-close':'close',
          'click .about-comein__modale-card-item':'flip',
        },
        flip:function(e){
          $(e.currentTarget).toggleClass('about-comein__modale-card-rotated')
        },
        setup:function(){
          this.delegateEvents();
          InternalLinkView.initializeLinksOfView(this);
        },
        close:function(){
          this.trigger('close',this);
        }
    });

    return WidgetInstanceView.extend({
      name: 'AboutComeInWidgetInstanceView',
      events: {
        'click .about-comein__strate1-item--comein':'openPopinComeIn',
        'click .about-comein__advantage':'openAdvantagesModal',
        'click a[href^="#"]':'smoothAnchor',
      },
      handleInfoBulle: function() {
        var   view = this
            , infosButton = view.$('.about-comein__strate1-item-infos')
            , infobulle = view.$('.about-comein__strate1-item-infosbulle')
            , isOpen = false

        infosButton.on('click', function(e) {
          var   x = e.pageX + 10
              , y = (e.pageY + 10 - $(document).scrollTop())

          if(!isOpen) {
            infobulle.addClass('active')
            isOpen = true
          } else {
            infobulle.removeClass('active')
            isOpen = false
          }
        })

        view.$('.about-comein__strate-wrapper').on('scroll', function(){
          close()
        })

        $(document).on('scroll', function() {
          close()
        })

        function close() {
          if(isOpen) {
            infobulle.removeClass('active')
            isOpen = false
          }
        }
      },
      openPopinComeIn: function () {
        var modalView = new ComeInInformationsView()
        app.displayModal(modalView)
      },
      boardMobileSlider: function() {
        var view = this
        ,   container = view.$('.about-comein__strate2-board--mobile-wrapper')
        ,   arrows = view.$('.about-comein__strate2-board--mobile-arrow')
        ,   activeSlide = 0


        container.on('scroll', function() {
          var position = $(this).scrollLeft()
          ,   slideWidth = $(this).get(0).scrollWidth / 3
          activeSlide = Math.round(position / slideWidth)
          setArrow()
        })

        arrows.on('click', function() {
          var slideWidth = container.get(0).scrollWidth / 3
          ,   direction = $(this).hasClass('icon-arrow-left') ? '-=' : '+='
          container.animate({
            scrollLeft: direction + slideWidth
          }, 400)
          setArrow()
        })

        function setArrow() {
           $(arrows[1]).toggleClass('inactive',activeSlide === 2)
           $(arrows[0]).toggleClass('inactive',activeSlide === 0)
        }
      },
      jauge: function()
      {
        var view = this
        ,   status
        ,   container = view.$('.about-comein__strate2-board-jauge')
        ,   jauges = []
        ,   itemNbrTh = 14

        for (var i = 0; i < itemNbrTh * 3; i++) {
          var height = ((6.5 / itemNbrTh * 3) * i) + 5
          if (i < itemNbrTh) {
            status = 'ichi';
          }else if (i > itemNbrTh && i < itemNbrTh * 2) {
            status = 'ni';
          }else if (i > itemNbrTh * 2) {
            status = 'san';
          }else{
            status = false;
          }
          if(status){
            jauges.push('<span data-status="'+status+'" class="cell about-comein__strate2-board-'+status+' about-comein__strate2-board-jauge-item " style="height:' + height + 'px"></span>')
          }
        }

        container.html(jauges.join(''))

        view.$('.about-comein__strate2-board-ichi').addClass('active')

        function toggleActive(event){

          var targetStatusCode, $el = $(event.currentTarget); // default status
          if(!!(targetStatusCode = $el.data('status'))){
            // noop
          }else if($el.index()===2){
            targetStatusCode = 'ni'
          }else if($el.index()===3){
            targetStatusCode = 'san';
          }else{
            targetStatusCode = 'ichi';
          }
          var isIchi = targetStatusCode === 'ichi',
              isNi = targetStatusCode === 'ni',
              isSan = targetStatusCode === 'san',
              isNoSan = targetStatusCode !== 'san';
          view.$('.about-comein__strate2-board-san').toggleClass('active',isSan)
          view.$('.about-comein__strate2-board-ni').toggleClass('active', isNi || isSan)
          view.$('.about-comein__strate2-board-ichi').toggleClass('active',isIchi || isNi || isSan)
          view.$('.about-comein__strate2-board-nosan').toggleClass('active', isNi && isNoSan)
        }

        view.$('.about-comein__strate2-board .cell')
          .hover(function (e) {
            toggleActive(e)
          }, function(e) {
            toggleActive(false)
          }
        )
        toggleActive(false)
      },
      setPagination: function() {
        var view = this
        ,   wrapper = view.$('.about-comein__strate-wrapper')

        wrapper.scroll(function() {
          var position = $(this).scrollLeft()
          ,   slideWidth = $(this).get(0).scrollWidth / 3
          ,   activeSlide = Math.round(position / slideWidth)
          ,   bullets = $(this).next().children('.about-comein__strate-pagination-bullet')

          bullets.each(function(i,e) {
            $(this).toggleClass('active', activeSlide === i)
          })
        })
      },
      openAdvantagesModal: function(event){
          var view = this,
              status = $(event.currentTarget).data('status'),
              advantageModalView = new AdvantageModalView();
          advantageModalView.$el.append(view.$('.about-comein__modale--'+status).clone());
          advantageModalView.setup();
          app.displayModal(advantageModalView);
          view.attachView(advantageModalView);
      },
      smoothAnchor:function(e){
          console.log('smoothAnchor',$(e.currentTarget).attr('href'));
          var href = $(e.currentTarget).attr('href');
          $(href).get(0).scrollIntoView({behavior: "smooth"})
          e.preventDefault();
      },

      getTemplate: function() {
        return AboutComeInTemplate
      },
      initialize:function(){
        var view = this,
            customerModel = app.getCustomer();
        view.subviews = [];
        WidgetInstanceView.prototype.initialize.apply(view,arguments);
        function rerender(){
          view.rerender();
        }
        customerModel.on('login logout',rerender)
      },
      afterRender: function () {
        var view = this

          view.jauge()
          view.setPagination()
          view.boardMobileSlider()
          view.handleInfoBulle()

          InternalLinkView.initializeLinksOfView(view);
      },
    })
  });

